import * as React from "react";
import * as classNames from 'classnames';
import "./Popover.scss";
import Overlay from "modules/cars/rating/tires/components/utils/Overlay";

export interface PopoverProps {
    isOpen: boolean,
    content: JSX.Element,
    children?: JSX.Element[] | JSX.Element,
    align: "left" | "right" | "center"
}

const Popover: React.SFC<PopoverProps> = ({isOpen, content, children, align}) =>
    <Overlay isOpen={isOpen} className={classNames("cr-rating__popover", {
            "cr-rating__popover--align-left": align === 'left',
            "cr-rating__popover--align-right": align === 'right',
            "cr-rating__popover--align-center": align === 'center',
        })}
        content={<div className="cr-rating__popover__content">{content}</div>}
        align={align}
    >
        {children}
    </Overlay>

export default Popover;



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/components/utils/Popover.tsx